import FormControlLabel from "@mui/material/FormControlLabel";
import { useTranslation } from "react-i18next";
import { Checkbox } from "src/components/Default/LekUI/Checkbox";

import Filter from "./DefaultFilters";

export default function CommentsNotificationsFilter(props) {
	const { t } = useTranslation();

	const setSelectedType = (option) => {
		props.setSelectedData({
			commentsNotifications:
				props.selectedData.commentsNotifications === option ? null : option,
		});
	};

	const renderFilter = (type, text) => {
		return (
			<FormControlLabel
				label={text}
				control={
					<Checkbox
						checked={props.selectedData.commentsNotifications === type}
						onChange={() => setSelectedType(type)}
					/>
				}
			/>
		);
	};

	const renderFilters = () => {
		return (
			<div>
				{renderFilter(
					"unread",
					t("filters.exams.commentsNotifications.unread"),
				)}
				{renderFilter("all", t("filters.exams.commentsNotifications.all"))}
			</div>
		);
	};

	return (
		<Filter
			{...props}
			title={t("filters.exams.commentsNotifications.title")}
			renderFilterDetails={renderFilters}
		/>
	);
}
